import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Helmet } from 'react-helmet-async'; // Correct import
import BlogSkeleton from "../components/BlogSkeleton";
function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [activeTab, setActiveTab] = useState("all"); // 'all' is default

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 12;
  const timestamp = new Date().getTime();
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('en-GB', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    return `${day} ${month}, ${year}`;
  };

  const calculateReadingTime = (content) => {
    const wordsPerMinute = 200;
    const wordCount = content.split(" ").length;
    return Math.ceil(wordCount / wordsPerMinute);
  };

  useEffect(() => {
    fetch(`https://www.pixelliongroup.com/seotic/getBlogs.php?_=${timestamp}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (Array.isArray(data)) {
          setBlogs(data);
        } else {
          throw new Error("Expected an array but received something else");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching blogs:", error);
        setError(error);
        setLoading(false);
      });
  }, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const filteredBlogs = blogs.filter((post) => {
  const matchesSearch =
    post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    post.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    post.type.includes(searchTerm.toLowerCase());

  const matchesTab =
    activeTab === "all" || post.type.includes(activeTab); // This allows for 'blog and news'

  return matchesSearch && matchesTab;
});

 const totalPages = Math.ceil(filteredBlogs.length / postsPerPage);
  const paginatedBlogs = filteredBlogs.slice(
    (currentPage - 1) * postsPerPage,
    currentPage * postsPerPage
  );

useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);

  if (loading) {
    return (
      <>
        <Navbar />
         <BlogSkeleton />
        <Footer />
      </>
    );
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      <Helmet>
        <title>Seotic Blog - Powerful SEO Tools for Small Businesses</title>
        <meta
          name="description"
          content="Seotic provides easy to use SEO tools for small businesses to enhance online visibility, drive traffic, and grow your brand. Get started with Seotic today!"
        />
        <meta name="keywords" content="SEO, SEO tools, small business, digital marketing, online visibility, Seotic" />
        <link rel="icon" href="https://www.seotic.co/favicon.ico" />

        {/* Open Graph Meta Tags */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.seotic.co" />
        <meta property="og:title" content="Seotic - SEO Tools for Small Businesses" />
        <meta
          property="og:description"
          content="Optimize your website's SEO with Seotic's powerful, user friendly tools designed for small businesses. Start improving your search rankings today!"
        />
        <meta property="og:image" content="https://www.seotic.co/og-image.jpg" />

        {/* Twitter Card Meta Tags */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://www.seotic.co" />
        <meta property="twitter:title" content="Seotic - SEO Tools for Small Businesses" />
        <meta
          property="twitter:description"
          content="Optimize your website's SEO with Seotic's powerful, user friendly tools designed for small businesses. Start improving your search rankings today!"
        />
        <meta property="twitter:image" content="https://www.seotic.co/og-image.jpg" />
      </Helmet>
      <Navbar />
      <div className="bg-slate-100 h-full">
        <div className="container mx-auto py-12 px-2 md:px-0">
          <h2 className="text-center text-base/7 uppercase text-slate-400">Blog & News</h2>
      <p className="mx-auto mt-2 max-w-lg text-center text-4xl font-semibold tracking-tight text-balance text-gray-950 sm:text-5xl">
        Learn, inspire and always up to date
      </p>

          {/* Search Bar */}
          <div className="mb-10 mx-5 flex justify-center mt-10">
            <input
              type="text"
              placeholder="Search by title, category or description..."
              value={searchTerm}
              onChange={handleSearch}
              className="px-4 py-3 border border-slate-200 rounded-lg w-full max-w-md focus:outline-none"
            />
          </div>
          
          <div className="flex justify-center  gap-2 mb-5">
  {["all", "blog", "news"].map((tab) => (
    <button
      key={tab}
      onClick={() => {
        setActiveTab(tab);
        setCurrentPage(1);
      }}
      className={`px-4 py-2 text-sm rounded-lg border ${
        activeTab === tab ? "bg-black text-white" : "bg-white text-black border-slate-300"
      }`}
    >
      {tab.charAt(0).toUpperCase() + tab.slice(1)}
    </button>
  ))}
</div>


          <div className="grid gap-5 md:grid-cols-3 mx-5">
            {paginatedBlogs.map((post) => (
              <Link
                key={post.parama}
                to={`/blog/${post.parama}`}
                className="bg-white rounded overflow-hidden border border-slate-200"
              >
               <img className="w-full object-cover transition-all duration-300 blur-xl" loading="lazy" decoding="async" src={post.image} alt={post.title} onLoad={(e)=>e.target.classList.remove('blur-xl')} />
                <div className="px-10 py-5">
                  <p className="text-slate-400 text-sm mb-5">
                    {formatDate(post.date)} in {post.category} • {calculateReadingTime(post.content)} min read
                  </p>
                  <h2 className="text-xl font-medium mb-2">{post.title}</h2>
                  <p className="text-slate-500 text-sm mb-4">{post.description}</p>
                </div>
              </Link>
            ))}
          </div>

          {/* No Results Message */}
          {filteredBlogs.length === 0 && (
            <div className="text-center text-slate-500 mt-8">
              No posts found for "{searchTerm}"
            </div>
          )}
          
          
          {totalPages > 1 && (
            <div className="flex justify-center mt-8">
              {Array.from({ length: totalPages }, (_, idx) => (
                <button
                  key={idx + 1}
                  onClick={() => setCurrentPage(idx + 1)}
                  className={`mx-1 px-3 py-1 rounded border ${
                    currentPage === idx + 1
                      ? "bg-black text-white border-black"
                      : "bg-white text-black border-slate-300"
                  }`}
                >
                  {idx + 1}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Blog;
